import React,{useEffect,useState} from "react";
import CustomHeading from '../../../constants/CustomHeading'
import {  Formik, Form} from 'formik';
import * as Yup from 'yup';
import CustomInput from '../../../constants/CustomInput';
import CustomTextArea from '../../../constants/CustomTextArea';
import CustomDropdown from '../../../constants/CustomDropdown';
import CustomCheckbox from "../../../constants/CustomCheckbox";
import CustomButton from '../../../constants/CustomButton';
import CustomRichTextField from "../../../constants/CustomRichTextField";
import CustomTableWithAll from '../../../constants/CustomTableWithAll';
import {connect} from 'react-redux';
import {getResearchPublicationData,setResearchPublicationData} from '../../../redux/actions/dataAction';
import CustomLine from "../../../constants/CustomLine";


const validationSchema = Yup.object().shape({
    paper_title: Yup.string()
    .required('Required'),
    type: Yup.string()
    .required('Required'),
  journal_title: Yup.string()
    .required('Required'),
  status: Yup.string()
    .required('Required'),
    level_status: Yup.string()
    .required('Required'),
 
});
const ResearchPublication = (props) => {
    const [isLoading,setIsLoading]=useState(false);
    useEffect(()=>{
        props.getResearchPublicationData();
    },[isLoading])
    const columns = [ 
        {title:'Paper title',field:'paper_title'},
        {title:'Authors',field:'authors' },
        {title:'Page No.',field:'page_no'},
        {title:'Journal title',field:'journal_title'},
        {title:'Piblication year',field:'publication_year'},
        {title:'Publisher',field:'publisher'},
        {title:'Volume No.',field:'volume_no'},
        {title:'ISSN/ISBN',field:'issn_isbn'},
        {title:'Scopus/SCI/Peer Reviewed',field:'scopus_sci_peer_reviewed'},
        {title:'DOI',field:'direct_object_identifier'},
        {title:'Impact Factor',field:'impact_factor'},

      ]
  return (
    <div className="customContainer">
        <CustomHeading title="Research Publication"/>
        <CustomTableWithAll data={props?.research_publication?.data}  columns={columns} api="/api/Research-Publication/"  title={'All Research publications'} />
        <CustomLine/>
        <Formik 
                initialValues={{
                    paper_title:'',
                    journal_title:"",
                    authors:'',
                    abstract:'',
                    page_no:0,
                    h_index:0,
                    i10_index:0,
                    scopus_sci_peer_reviewed:'',
                    status:'',
                    publisher:'',
                    type:'',
                    level_status:'',
                    issn_isbn:'',
                    published_url:'',
                    index_terms:'',
                    volume_no:'',
                    issue_no:0,
                    direct_object_identifier:'',
                    publication_year:'',
                    impact_factor:'',
                    awards_it_has_won:false,
                    institution_affliation:false,

                   }}
                   validationSchema={validationSchema}
                   onSubmit={values => {
                    console.log(values);
                    props.setResearchPublicationData(values);
                    setIsLoading(true)
                    
                  }}
            >
            {({ errors, touched,handleChange,handleSubmit,setFieldValue,values }) => (

            <Form onSubmit={handleSubmit} style={{marginTop:0}}>
                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Paper Title'}
                        label={'Paper Title :'}
                        onChange={handleChange('paper_title')}
                        errorText={
                            errors.paper_title && touched.paper_title ?errors.paper_title :null
                        }
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                    label="Type : "
                    data={[{value:"Journal"},{value:"Conference"}]}
                    onChange={handleChange('type')}
                    errorText={
                        errors.type && touched.type ?errors.type :null
                    }
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Publication/Journal Title'}
                        label={'Publication/Journal Title :'}
                        onChange={handleChange('journal_title')}
                        errorText={
                            errors.journal_title && touched.journal_title ?errors.journal_title :null
                        }
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                    label="Level / Status : "
                    data={[{value:"State"},{value:"National"},{value:'International'},{value:'Institute'}]}
                    onChange={handleChange('level_status')}
                    errorText={
                        errors.level_status && touched.level_status ?errors.level_status :null
                    }
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomTextArea
                        type={'text'}
                        label={'Author(s)'}
                        placeholder={'Enter Author (s)'}
                        onChange={handleChange('authors')}
                    />	
                    </div>
                    <div className="col-md-6">
                    <CustomTextArea
                        type={'text'}
                        placeholder={'Enter Index term(s)'}
                        label={'Index Term(s) :'}
                        onChange={handleChange('index_terms')}
                        
                    />
                    
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Page no'}
                        label={'Page No :'}
                        onChange={handleChange('page_no')}
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Published URL'}
                        label={'Published URL :'}
                        onChange={handleChange('published_url')}
                        
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter h-Index'}
                        label={'h-Index :'}
                        onChange={handleChange('h_index')}
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'International Standard Serial Number'}
                        label={'SSN / ISBN :'}
                        onChange={handleChange('issn_isbn')}
                        
                    />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'number'}
                        placeholder={'Only Digits!'}
                        label={'i10-Index :'}
                        onChange={handleChange('i10_index')}
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Volume No'}
                        label={'Volume No. :'}
                        onChange={handleChange('volume_no')}
                        
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Scopus / SCI /Peer Reviewed'}
                        label={'Scopus / SCI /Peer Reviewed :'}
                        onChange={handleChange('scopus_sci_peer_reviewed')}
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomInput
                        type={'number'}
                        placeholder={'Enter issue no.'}
                        label={'Issue No. :'}
                        onChange={handleChange('issue_no')}
                        
                    />
                    </div>
                </div>


                <div className="row">
                    <div className="col-md-6">
                    <CustomInput
                        type={'text'}
                        placeholder={'Enter Digital Object Identifier (DOI)'}
                        label={'Digital Object Identifier (DOI) :'}
                        onChange={handleChange('direct_object_identifier')}
                        
                    />
                    </div>
                    <div className="col-md-6">
                    <CustomDropdown 
                    label="Status : "
                    data={[{value:"Communicated"},{value:"Published"},{value:'Accepted'}]}
                    onChange={handleChange('status')}
                    errorText={
                        errors.status && touched.status ?errors.status :null
                    }
                    />
                    </div>
                </div>



                <div className="row">
                    <div className="col-md-6">
                    <CustomTextArea
                        type={'text'}
                        label={'Publisher'}
                        placeholder={'Enter Publisher'}
                        onChange={handleChange('publisher')}
                    />	
                    </div>
                    <div className="col-md-6">
                    <CustomTextArea
                        type={'text'}
                        placeholder={'Enter Impact factor'}
                        label={'Impact factor :'}
                        onChange={handleChange('impact_factor')}
                        
                    />
                    
                    </div>
                </div>
                <CustomInput
                type={'date'}
                placeholder={'Select Year'}
                label={'Publication Year :'}
                onChange={handleChange('publication_year')}
                
                    />
                    <div className="row">
                    <div className="col-md-6">
                        <CustomCheckbox label={'Any awards it has won '} onChange={()=>setFieldValue('awards_it_has_won',!values.awards_it_has_won)}/>
                    </div>
                    <div className="col-md-6">
                    <CustomCheckbox label={'Institutional affiliation (If yes, check) '} onChange={()=>setFieldValue('institution_affliation',!values.institution_affliation)}/>
                    </div>
                </div>
                <div className="row mb-5">
                    <div className="col-md-6">
                        <CustomRichTextField label={'Abstract'} onChange={handleChange('abstract')}/>
                    </div>
                    <div className="col-md-2 my-3">
                    <CustomButton type="submit" label="Save" isIcon/>
                    </div>
                </div>
                
               
            </Form>
            )}
              </Formik>
    </div>
  );
};
const mapActionWithProps = {
    getResearchPublicationData,
    setResearchPublicationData,
  }
  
  const mapStateWithProps = (state)=>(
    {
        research_publication:state.data.research_publication
    }
  )
  export default connect(mapStateWithProps,mapActionWithProps)(ResearchPublication);

